import {defineStore} from 'pinia';
import {Video} from './types';

interface State {
    videos: Video[];
    playVideo?: Video;
}

export const useStore = defineStore('global', {
    state: () => ({
        videos: [],
        playVideo: undefined,
    } as State),
    getters: {},
    actions: {
        async fetchVideos() {
            for (const video of window.GalleryVideos) {
                this.videos.push({
                    title: video.title,
                    embed: addAutoplay(video.embed),
                    thumbnail: video.thumbnail,
                });
            }
        },
        setPlayVideo(video?: Video) {
            this.playVideo = video;
        },
    },
});

function addAutoplay(embed: string) {
    const matches = embed.match('.*?src="(.*?)".*?');

    if (matches) {
        return embed.replace(matches[1], matches[1] + '&autoplay=1');
    } else {
        return embed;
    }
}
